import ProductsMegaMenu from 'organisms/MegaMenu/ProductsMegaMenu/ProductsMegaMenu';
import ProductsMegaMenuSideBar from 'organisms/MegaMenu/ProductsMegaMenu/ProductsMegaMenuSideBar';

export interface ExpandableMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface IMenuLink {
  text: string;
  href?: string;
  trackingSlug?: string;
  useExpandableMenu?: boolean;
  expandableMenu?: (props: ExpandableMenuProps) => JSX.Element;
}

type HeaderLinkSubSet = 'top_menu' | 'side_menu';

// Desktop TopBar Links
const MENU_LINKS: IMenuLink[] = [
  {
    text: 'Product',
    trackingSlug: 'all_features',
    useExpandableMenu: true,
    expandableMenu: ProductsMegaMenu,
  },
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
  { text: 'Branded Apps', href: '/pro', trackingSlug: 'branded_apps' },
  { text: 'Services', href: '/pro/services', trackingSlug: 'mighty_pro' },
];

// Mobile SideMenu Links
const SIDE_BAR_LINKS: IMenuLink[] = [
  {
    text: 'Product',
    trackingSlug: 'all_features',
    useExpandableMenu: true,
    expandableMenu: ProductsMegaMenuSideBar,
  },
  { text: 'Pricing', href: '/pricing', trackingSlug: 'pricing' },
  { text: 'Branded Apps', href: '/pro', trackingSlug: 'branded_apps' },
  { text: 'Services', href: '/pro/services', trackingSlug: 'mighty_pro' },
];

export const createHeaderLinks = (subset: HeaderLinkSubSet): IMenuLink[] => {
  switch (subset) {
    case 'top_menu':
      return MENU_LINKS;
    case 'side_menu':
      return SIDE_BAR_LINKS;
    default:
      return [];
  }
};
